import { useApi } from '@/composables/useApi'

const api = useApi()

class YouTubeService {
  constructor() {
 // Ajuste conforme sua configuração do backend
    this.baseURL = '/youtube'
    this.authToken = null
    this.streamId = null
  }

  // =============================================
  // AUTENTICAÇÃO
  // =============================================

  /**
   * Inicia o processo de autenticação com YouTube
   */
  async authenticate() {
    try {
      const response = await api.get(`${this.baseURL}/auth/youtube`)

      console.log('Response from YouTube auth:', response)

      if (response.data.url) {
        // Redireciona para a URL de autenticação do Google
        window.location.href = response.data.url
        return response.data
      }

      throw new Error('URL de autenticação não recebida')
    } catch (error) {
      console.error('Erro na autenticação:', error)
      throw new Error(error.response?.data?.message || 'Erro ao autenticar com YouTube')
    }
  }

  async createWebinario(data) {
    try {
      const response = await api.post(`${this.baseURL}/webinario`, {
        user_id: data.user_id,
        titulo: data.titulo,
        descricao: data.descricao,
        stream_key: data.stream_key,
        qualidade: data.qualidade || '1080p',
        bitrate: data.bitrate || 3000,
        fps: data.fps || 30,
        video_url: data.video_url,
        video_key_name: data.video_key_name,
        resposta_ia: data.ai_chat_enabled || 0,
        palavra_chave: data.ai_keyword || null,
      })

    } catch (error) {
      console.error('Erro ao criar webnario:', error)
      throw new Error(error.response?.data?.message || 'Erro ao criar webnari')
    }
  }

  async saveScheduledMessages(payload) {
    try {
      const response = await api.post(`${this.baseURL}/webinario`, {
        chat: payload.messages,
        user_id: payload.user_id,
      })

      console.log('Response completa do callback:', response)
    } catch (error) {
      console.error('Erro ao criar webnario:', error)
      throw new Error(error.response?.data?.message || 'Erro ao criar webnari')
    }
  }

  /**
   * Processa o callback de autenticação
   */
  async handleAuthCallback(code, userId) {
    try {
      const response = await api.post(`${this.baseURL}/auth/callback`, {
        code,
        userId,
      })

      console.log('Response completa do callback:', response)

      if (response.data.tokens) {
        this.authToken = response.data.tokens
        console.log('Tokens recebidos:', this.authToken)
        return response.data
      }

      throw new Error('Token não recebido')
    } catch (error) {
      console.error('Erro no callback de autenticação:', error)
      throw new Error(error.response?.data?.message || 'Erro no callback de autenticação')
    }
  }

  /**
   * Verifica se o token é válido
   */
  static isTokenValid(token) {
    if (!token) return false
    try {
      const tokenData = typeof token === 'string' ? JSON.parse(token) : token
      if (!tokenData.expiry_date) return false
      // Verifica se o token expira em menos de 5 minutos
      const now = new Date().getTime()
      const expiryTime = tokenData.expiry_date
      return expiryTime > (now + 5 * 60 * 1000) // 5 minutos de margem
    } catch (error) {
      return false
    }
  }

  /**
   * Renova o token de acesso
   */
  async refreshToken() {
    try {
      const token = localStorage.getItem('youtube_token')
      if (!token) {
        throw new Error('Nenhum token encontrado para renovar')
      }

      const tokenData = JSON.parse(token)
      const response = await api.post(`${this.baseURL}/auth/refresh`, {
        refreshToken: tokenData.refresh_token,
      })

      if (response.data.tokens) {
        this.authToken = response.data.tokens
        localStorage.setItem('youtube_token', JSON.stringify(response.data.tokens))
        return response.data
      }

      throw new Error('Erro ao renovar token')
    } catch (error) {
      console.error('Erro ao renovar token:', error)
      throw new Error(error.response?.data?.message || 'Erro ao renovar token')
    }
  }

  // =============================================
  // STREAMING
  // =============================================

  /**
   * Cria uma nova transmissão
   */
  async createStream(streamData) {
    try {
      const response = await api.post(`${this.baseURL}/video/create-stream-single`, {
        userId: JSON.parse(localStorage.getItem('userData')).id,
        // title: streamData.title,
        // description: streamData.description,
        // scheduledStartTime: streamData.scheduledStartTime,
        // // privacy: streamData.privacy || 'unlisted',
        // // thumbnailUrl: streamData.thumbnailUrl,
        // videoPath: streamData.videoPath,
      }, {
        // headers: this.getAuthHeaders(),
      })

      if (response.data.streamId) {
        this.streamId = response.data.streamId
        return response.data
      }

      throw new Error('Stream não foi criada')
    } catch (error) {
      console.error('Erro ao criar stream:', error)
      throw new Error(error.response?.data?.message || 'Erro ao criar transmissão')
    }
  }

  /**
   * Cria uma nova transmissão com upload de vídeo
   */
  async createStreamWithVideo(userId) {
    try {
      const response = await api.post(`${this.baseURL}/video/create-stream-from-url`, {
        userId,
      })

      if (response.data.streamId) {
        this.streamId = response.data.streamId
        return response.data
      }

      throw new Error('Stream não foi criada')
    } catch (error) {
      console.error('Erro ao criar stream com vídeo:', error)
      throw new Error(error.response?.data?.message || 'Erro ao criar transmissão')
    }
  }

  /**
   * Inicia a transmissão
   */
  async startStream(streamId = null) {
    try {
      const id = streamId || this.streamId
      if (!id) {
        throw new Error('ID da transmissão não encontrado')
      }

      const response = await api.post(`${this.baseURL}/stream/start`, {
        streamId: id,
      }, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao iniciar stream:', error)
      throw new Error(error.response?.data?.message || 'Erro ao iniciar transmissão')
    }
  }

  /**
   * Para a transmissão
   */
  async stopStream(userId) {
    try {
      const id = userId || this.userId
      if (!id) {
        throw new Error('id do usuário não encontrado')
      }

      const response = await api.post(`${this.baseURL}/video/stop`, {
        userId: id,
      }, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      // Trata erro de live já encerrada
      if (error.response?.data?.error === 'Redundant transition') {
        // Lança um erro customizado para ser tratado no componente
        throw { code: 'LIVE_ALREADY_ENDED', message: 'A transmissão já estava encerrada.' }
      }
      console.error('Erro ao parar stream:', error)
      throw new Error(error.response?.data?.message || 'Erro ao parar transmissão')
    }
  }

  

  /**
   * Verifica o status da transmissão
   */
  async getStreamStatus(userId) {
    try {
      const id = userId || this.userId
      const response = await api.get(`${this.baseURL}/video/status`, {
        params: { userId: id },
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao obter status da stream:', error)
      throw new Error(error.response?.data?.message || 'Erro ao obter status da transmissão')
    }
  }

  // =============================================
  // CHAT
  // =============================================

  /**
   * Envia mensagem no chat
   */
  async sendChatMessage(message) {
    try {
      const userData = localStorage.getItem('userData')
      const userId = userData ? JSON.parse(userData).id : null
      
      if (!userId) {
        throw new Error('Usuário não encontrado')
      }

      const response = await api.post(`${this.baseURL}/chat/send`, {
        userId,
        message,
      }, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao enviar mensagem no chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao enviar mensagem no chat')
    }
  }

  /**
   * Simula mensagem no chat (para testes)
   */
  async simulateChatMessage(messageData, streamId = null) {
    try {
      const id = streamId || this.streamId
      if (!id) {
        throw new Error('ID da transmissão não encontrado')
      }

      const response = await api.post(`${this.baseURL}/chat/simulate`, {
        streamId: id,
        message: messageData.message,
        authorName: messageData.authorName || 'Usuário Simulado',
        authorChannelId: messageData.authorChannelId,
      }, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao simular mensagem no chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao simular mensagem no chat')
    }
  }

  /**
   * Agenda mensagem no chat
   */
  async scheduleChatMessage(messageData, streamId = null) {
    try {
      const id = streamId || this.streamId
      if (!id) {
        throw new Error('ID da transmissão não encontrado')
      }

      const response = await api.post(`${this.baseURL}/chat/schedule`, {
        streamId: id,
        message: messageData.message,
        scheduledTime: messageData.scheduledTime,
        authorName: messageData.authorName,
      }, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao agendar mensagem no chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao agendar mensagem no chat')
    }
  }

  /**
   * Cancela mensagem agendada
   */
  async cancelScheduledMessage(messageId) {
    try {
      const response = await api.delete(`${this.baseURL}/chat/schedule/${messageId}`, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao cancelar mensagem agendada:', error)
      throw new Error(error.response?.data?.message || 'Erro ao cancelar mensagem agendada')
    }
  }

  // =============================================
  // MÉTODOS AUXILIARES
  // =============================================

  /**
   * Retorna os headers de autenticação
   */
  // getAuthHeaders() {
  //   const token = this.authToken || localStorage.getItem('youtube_token')
  //   if (!token) {
  //     throw new Error('Token de autenticação não encontrado')
  //   }

  //   const tokenData = typeof token === 'string' ? JSON.parse(token) : token
  //   return {
  //     Authorization: `Bearer ${tokenData.access_token}`,
  //     'Content-Type': 'application/json',
  //   }
  // }

  /**
   * Verifica se está autenticado
   */
  static isAuthenticated() {
    const token = localStorage.getItem('youtube_token')
    return token && YouTubeService.isTokenValid(token)
  }

  /**
   * Faz logout (limpa dados locais)
   */
  logout() {
    localStorage.removeItem('youtube_token')
    localStorage.removeItem('youtube_credentials')
    this.authToken = null
    this.streamId = null
  }

  /**
   * Obtém informações do canal atual
   */
  async getChannelInfo() {
    try {
      const response = await api.get(`${this.baseURL}/channel/info`, {
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao obter informações do canal:', error)
      throw new Error(error.response?.data?.message || 'Erro ao obter informações do canal')
    }
  }

  /**
   * Lista transmissões existentes
   */
  async listStreams(maxResults = 10) {
    try {
      const response = await api.get(`${this.baseURL}/streams`, {
        params: { maxResults },
        // headers: this.getAuthHeaders(),
      })

      return response.data
    } catch (error) {
      console.error('Erro ao listar transmissões:', error)
      throw new Error(error.response?.data?.message || 'Erro ao listar transmissões')
    }
  }

  /**
   * Verifica se existe integração do YouTube para o usuário
   */
  async checkIntegration(userId) {
    try {
      if (!userId) return false
      const response = await api.get(`${this.baseURL}/integration/user/${userId}`)
      console.log('Verificação de integração:', response.data)
      const integration = response.data
      // Se não existe integração ou não tem expiry_date, não está autenticado
      if (!integration) return false
      // Se a data atual for depois do expiry_date, não está autenticado
      // const now = new Date()
      // const expiry = new Date(integration.expiry_date)
      // if (now > expiry) return false
      return true
    } catch (e) {
      console.error('Integração não encontrada')
      return false
    }
  }

  /**
   * Salva a integração do YouTube na tabela de integrações
   */
  async saveIntegration(tokens) {
    try {
      const userData = localStorage.getItem('userData')
      if (!userData) {
        throw new Error('Dados do usuário não encontrados')
      }

      const userId = JSON.parse(userData).id
      if (!userId) {
        throw new Error('ID do usuário não encontrado')
      }

      // Converte expiry_date para string ISO, se for um número
      let expiryDateFormatted = tokens.expiry_date
      expiryDateFormatted = new Date(expiryDateFormatted).toISOString()
      const integrationData = {
        id_user: userId,
        access_token: tokens.access_token,
        refresh_token: tokens.refresh_token,
        expiry_date: expiryDateFormatted,
      }

      const response = await api.post(`${this.baseURL}/integration`, integrationData)
      console.log('Integração salva com sucesso:', response.data)
      
      return response.data
    } catch (error) {
      console.error('Erro ao salvar integração:', error)
      throw new Error(error.response?.data?.message || 'Erro ao salvar integração')
    }
  }

  /**
   * Busca mensagens do chat em tempo real
   */
  async getChatMessages(userId) {
    try {
      if (!userId) {
        throw new Error('ID do usuário é obrigatório')
      }

      const params = { userId }

      const response = await api.get(`${this.baseURL}/chat/messages`, {
        params,
      })

      return response.data
    } catch (error) {
      console.error('Erro ao buscar mensagens do chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao buscar mensagens do chat')
    }
  }

  /**
   * Inicia o monitoramento do chat (para polling)
   */
  async startChatMonitoring(userId) {
    try {
      const response = await api.post(`${this.baseURL}/chat/start-monitoring`, {
        userId,
      })

      return response.data
    } catch (error) {
      console.error('Erro ao iniciar monitoramento do chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao iniciar monitoramento do chat')
    }
  }

  /**
   * Para o monitoramento do chat
   */
  async stopChatMonitoring(userId) {
    try {
      const response = await api.post(`${this.baseURL}/chat/stop-monitoring`, {
        userId,
      })

      return response.data
    } catch (error) {
      console.error('Erro ao parar monitoramento do chat:', error)
      throw new Error(error.response?.data?.message || 'Erro ao parar monitoramento do chat')
    }
  }

  /**
   * Busca o broadcastId (streamId) atual do usuário
   */
  async getCurrentBroadcastId(userId) {
    try {
      const response = await api.get(`${this.baseURL}/video/broadcast/${userId}`)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar broadcastId:', error)
      throw new Error(error.response?.data?.message || 'Erro ao buscar broadcastId')
    }
  }

  /**
   * Busca todos os webinários de um usuário
   */
  async getWebinariosByUser(userId) {
    try {
      if (!userId) {
        throw new Error('ID do usuário é obrigatório')
      }

      const response = await api.get(`${this.baseURL}/webinario/user/${userId}`)
      console.log('Webinários encontrados:', response.data)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar webinários do usuário:', error)
      throw new Error(error.response?.data?.message || 'Erro ao buscar webinários do usuário')
    }
  }

  async updateTriggers(payload) {
    console.log('Atualizando triggers com payload:', payload)
    try {
      const response = await api.post(`${this.baseURL}/webinario`, {
        triggers: payload.triggers,
        user_id: payload.user_id,
      })

      console.log('Response completa do callback:', response)
    } catch (error) {
      console.error('Erro ao criar webnario:', error)
      throw new Error(error.response?.data?.message || 'Erro ao criar webnario')
    }
  }
}

// Instância singleton do serviço
export const youtubeService = new YouTubeService()

// Export da classe para casos onde precisar criar múltiplas instâncias
export default YouTubeService
// Export da classe para casos onde precisar criar múltiplas instâncias
